import { Stack, TextField } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import { CrudPage } from '../../shared/components/CrudPage';
import { resources } from '../../core/services/resources';
import type { Persona } from '../../core/types/data-models';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 80 },
  { field: 'name', headerName: 'Name', flex: 1, minWidth: 220 },
  { field: 'description', headerName: 'Description', flex: 2, minWidth: 240 },
  { field: 'lineOfBizCount', headerName: 'Lines of business', width: 160, type: 'number' },
];

export function PersonasPage() {
  return (
    <CrudPage<Persona>
      title="Personas"
      description="Global persona catalog used as the parent reference for line-of-business personas."
      cacheKey={['personas']}
      service={resources.personas}
      columns={columns}
      defaultValues={{ name: '', description: null }}
      renderForm={({ values, setValues }) => (
        <Stack spacing={2}>
          <TextField
            label="Name"
            required
            value={values.name ?? ''}
            onChange={(e) => setValues({ ...values, name: e.target.value })}
          />
          <TextField
            label="Description"
            multiline
            minRows={2}
            value={values.description ?? ''}
            onChange={(e) =>
              setValues({ ...values, description: e.target.value === '' ? null : e.target.value })
            }
          />
        </Stack>
      )}
    />
  );
}
